import { render, staticRenderFns } from "./CreateStaffModal.vue?vue&type=template&id=aa1ea554&scoped=true&"
import script from "./CreateStaffModal.vue?vue&type=script&lang=js&"
export * from "./CreateStaffModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1ea554",
  null
  
)

export default component.exports